export type WebSignupSurface = 'use_web' | 'my_web';

export type ClientStamp = {
  signupSurface: string;
  platform: 'web';
  appId: string;
  userAgent?: string;
};

export function buildWebClientStamp(
  surface: WebSignupSurface,
  existingClient?: { signupSurface?: string } | null,
): ClientStamp {
  const stamp: ClientStamp = {
    signupSurface: existingClient?.signupSurface || surface,
    platform: 'web',
    appId: surface === 'my_web' ? 'my.x9.app' : 'use.x9.app',
  };
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    stamp.userAgent = String(navigator.userAgent).slice(0, 300);
  }
  return stamp;
}
